enum ExamType {
    DNATest= "Test del DNA",
    BloodExams = "Esami del sangue",
    OtherExams = "Altri esami",
}

export default ExamType
